import React, { FunctionComponent, useState, useEffect } from "react"
import { Card, Typography, Skeleton, Badge, Tag } from "antd"
import { getColor } from "../utils"
import { BrokersService } from "../api/services.gen"
import { Link } from "react-router"
import { PositionDto, PriceDto } from "../api"

const { Text } = Typography

interface PositionProps {
  position: PositionDto
  useLastSale?: boolean
}

const Position:FunctionComponent<PositionProps> = (props) => {
  const [price, setPrice] = useState<PriceDto | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      const prices = await BrokersService.getPrices({
        broker: props.position.broker,
        action: props.position.action,
        currency: props.position.currency
      })
      setPrice(prices.price)
    }
    fetchData()
  }, [props.position])

  let win = 0
  if (price) {
    if (props.position.quantity > 0) {
      win = (((props.useLastSale && price.lastSale ? price.lastSale.price : price.bid) ?? 0) - props.position.openPrice)
    } else {
      win = (props.position.openPrice - ((props.useLastSale && price.lastSale ? price.lastSale.price : price.ask) ?? 0))
    }
  }

  return <Link to={`/positions/${props.position.id}`}><Card
      hoverable
      style={{
        maxWidth: 300,
        backgroundColor: getColor(props.position.traderId) + '20',
        borderColor: getColor(props.position.traderId) + '60',
        fontFeatureSettings: "'ss01' 1, 'tnum' 1"
      }}
    >
    <span><b>{props.position.quantity} × {props.position.action} @{props.position.openPrice.toFixed(4).replace(/0+$/,'')}</b></span><br />
    {
      price ? <>
        <Tag bordered={false} color={win > 0 ? '#52c41a' : '#ff4d4f'}>{win.toFixed(4)}</Tag> on {((props.useLastSale && price.lastSale ? price.lastSale.price : price.bid) ?? 0).toFixed(4).replace(/0+$/,'')}
      </> : <Skeleton />
    }<br />
    <span><i>{props.position.traderType} on {props.position.broker}</i></span><br />
  </Card></Link>
}

export { Position }